import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { ReelCuttingWrapperComponent } from '../reel-cutting-wrapper/reel-cutting-wrapper.component';

export const reelCuttingModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.REEL_CUTTING]: {
      inlineRoot: true,
      component: ReelCuttingWrapperComponent,
      dialogType: DIALOG_TYPE.DIALOG,
      dialogOptions: {
        onTop: true,
      },
    },
  },
};
